var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPassport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 54,
    viewBox: "0 0 68 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.9622 0.0478139C37.5171 -0.00152402 53.0162 -0.382131 58.4645 2.19754C68.6141 6.99741 67.5286 23.1873 67.1057 32.8011C66.704 41.985 65.0899 51.2465 54.3836 53.0226C45.2349 54.5451 32.6538 53.9248 23.3078 53.5654C15.2586 53.2552 6.63859 53.953 2.36733 45.481C-0.247578 40.3005 -0.148902 26.507 0.147125 20.4878C0.753277 8.23791 3.60783 1.59843 16.767 0.498904C21.2567 0.125345 26.4301 0.0830553 30.9622 0.0478139ZM21.5527 6.58861C16.1538 6.81416 9.19006 6.41945 7.3998 12.8334C5.83508 18.4368 6.01834 34.7958 7.28703 40.5683C8.63325 46.6792 14.2225 46.9611 19.3819 47.2994C27.2477 47.814 35.3039 47.5814 43.1627 47.2924C49.1115 47.0739 58.1051 48.3285 59.9235 40.7798C61.4248 34.5491 61.1781 21.7354 60.2689 15.3073C59.0284 6.51108 53.8409 7.13133 46.5741 6.77187C38.3417 6.37012 29.8204 6.24325 21.5457 6.58861H21.5527Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1355 28.5092C21.7653 28.333 26.1705 28.3048 29.7581 28.6854C32.2532 28.9533 33.8672 30.8704 34.1069 33.295C34.4311 36.5161 33.9518 40.2094 30.5122 41.3935C27.3405 42.486 16.7399 42.4719 13.5611 41.3935C9.79031 40.1177 9.09958 34.2888 10.5797 31.1594C11.9048 28.3471 15.5135 28.6361 18.1355 28.5092Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1166 12.3343C30.6881 11.3264 31.8229 25.5358 23.2663 26.6705C12.9124 28.052 11.8128 13.3141 21.1166 12.3343Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7734 21.8281H55.0532",
    stroke: "white",
    strokeWidth: 7.34,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7734 30.1504H47.6596",
    stroke: "white",
    strokeWidth: 7.34,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassport);
export default __webpack_public_path__ + "static/media/passport.0744b66515f17b89e59fe914776c4f4c.svg";
export { ForwardRef as ReactComponent };